import config from '../config';
import { isMetroShop } from '../constants/shops';

export const setLoaderColor = () => {
  //TODO: remove
  return isMetroShop(config.shopId) ? '#0b4a87' : '#0b4a87';
};
